/**
 * Force HTTPS on image URLs to prevent mixed content warnings
 *
 * @param {string} url - Image URL that may use http://
 * @returns {string} - URL forced to use https://
 */
export const forceHttps = (url) => {
  if (!url) return url;
  if (typeof url !== 'string') return url;

  // Replace http:// with https://
  return url.replace(/^http:\/\//i, 'https://');
};

/**
 * Force HTTPS on all image URLs in an object
 * Recursively processes nested objects and arrays
 *
 * @param {any} data - Object, array, or primitive to process
 * @returns {any} - Processed data with all http:// replaced with https://
 */
export const forceHttpsRecursive = (data) => {
  if (!data) return data;

  // Handle strings
  if (typeof data === 'string') {
    return forceHttps(data);
  }

  // Handle arrays
  if (Array.isArray(data)) {
    return data.map(item => forceHttpsRecursive(item));
  }

  // Handle objects
  if (typeof data === 'object') {
    const result = {};
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        // Check if this is an image-related property
        if (key.includes('pic') || key.includes('image') || key.includes('Image') || key.includes('img')) {
          result[key] = forceHttps(data[key]);
        } else {
          result[key] = forceHttpsRecursive(data[key]);
        }
      }
    }
    return result;
  }

  return data;
};
